// chatMedia.js — messages VOCAUX + GIF pour le chat. DÉSACTIVÉS par défaut (flags de build).
// Le code est prêt ; on active plus tard via REACT_APP_VOICE_MESSAGES_ENABLED / REACT_APP_GIF_ENABLED
// (+ côté backend CHAT_VOICE_ENABLED / CHAT_GIF_ENABLED + GIPHY_KEY). Rien de payant tant que off.
import { nakamaAuth } from './nakamaAuth';

const BASE = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

export const VOICE_ENABLED = process.env.REACT_APP_VOICE_MESSAGES_ENABLED === 'true';
export const GIF_ENABLED = process.env.REACT_APP_GIF_ENABLED === 'true';
// URL absolue d'un média renvoyé par le backend (chemin relatif → préfixe backend).
export function mediaUrl(u) { return /^https?:/.test(u || '') ? u : BASE + (u || ''); }

// Enregistre un blob audio → renvoie l'URL servie par le backend (ou null).
export async function uploadAudio(blob) {
  if (!VOICE_ENABLED || !BASE || !blob) return null;
  const data = await new Promise((res) => { const r = new FileReader(); r.onload = () => res(String(r.result)); r.readAsDataURL(blob); });
  const token = nakamaAuth.session && nakamaAuth.session.token;
  try {
    const r = await fetch(`${BASE}/chat/audio`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
      body: JSON.stringify({ data, mime: blob.type || 'audio/webm' }),
    });
    const d = await r.json();
    return d && d.url ? d.url : null;
  } catch { return null; }
}

// Recherche de GIF via le proxy backend (actif seulement si une clé Giphy est configurée).
export async function searchGif(q) {
  if (!GIF_ENABLED || !BASE) return [];
  try {
    const r = await fetch(`${BASE}/chat/gif?q=${encodeURIComponent(q || '')}`);
    const d = await r.json();
    return (d && d.gifs) || [];
  } catch { return []; }
}
